import { Stack } from '@eluve/components';

export const NoAppointmentPlaceholder: React.FC = () => (
  <Stack
    align="center"
    justify="center"
    fullHeight
    className="pointer-events-none pl-[62px] text-border-quaternary md:text-lg"
  >
    <span className="rounded-lg bg-bg-quaternary/30 p-3 text-text-disabled backdrop-blur-xs">
      No appointments found
    </span>
  </Stack>
);
